import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { ConnectedEditDialogForm } from '@mews-commander/legacy-form';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { closeDialog } from '../../../../modules/dialog/reducer';
import { isDialogOpen } from '../../../../modules/dialog/selectors';
import PrintReasonDialogForm, { formName } from './PrintReasonDialogForm';

interface DispatchProps {
    onClose: () => void;
}

interface StateProps {
    active: boolean;
}

type PrintReasonDialogProps = DispatchProps & StateProps;

const PrintReasonDialog = ({ onClose, active }: PrintReasonDialogProps) => (
    <ConnectedEditDialogForm
        active={active}
        formName={formName}
        primaryButtonTextKey={TextKey.Print}
        closeDialog={onClose}
        title={<LocalizedText textKey={TextKey.PrintReason} />}
    >
        <PrintReasonDialogForm />
    </ConnectedEditDialogForm>
);

export default pipe(
    PrintReasonDialog,
    connect<StateProps, DispatchProps, {}, ApplicationState>(
        (state) => ({
            active: isDialogOpen(state, { name: formName }),
        }),
        (dispatch) => ({
            onClose: () => dispatch(closeDialog(formName)),
        })
    )
);
